import React from "react";

type Props = {
  fill?: string;
};
export const FavoriteIcon: React.FC<Props> = ({ fill = "#262627" }) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.26489 2.73568C9.79319 1.8661 11.0659 1.8661 11.5942 2.73568L13.4136 5.73057C13.6034 6.04297 13.913 6.26577 14.2716 6.34804L17.7092 7.1367C18.7074 7.3657 19.1007 8.56469 18.429 9.33111L16.1159 11.9707C15.8746 12.2461 15.7564 12.6066 15.7882 12.9698L16.0933 16.4521C16.1819 17.4632 15.1522 18.2042 14.2089 17.8083L10.9598 16.4448C10.6208 16.3026 10.2382 16.3026 9.89929 16.4448L6.65019 17.8083C5.70681 18.2042 4.67719 17.4632 4.76578 16.4521L5.07087 12.9698C5.10269 12.6066 4.98445 12.2461 4.74317 11.9707L2.43002 9.3311C1.7584 8.56468 2.15168 7.3657 3.14981 7.1367L6.58746 6.34804C6.94604 6.26577 7.25561 6.04297 7.4454 5.73057L9.26489 2.73568Z"
      stroke={fill}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
